 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		95: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		95: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360","45":"EarlyProtect360.Dashboard","46":"EarlyProtect360.Details","47":"EarlyProtect360Plus","48":"EarlyProtect360Plus.Dashboard","49":"EarlyProtect360Plus.Details","50":"FamilyProtect360","51":"FamilyProtectLiteWithUpgrade","52":"FilipinoBond","53":"FlashPayShieldWithUpgrade","54":"FraudProtect360","55":"HIProtect360Protect360","56":"HomeProtect360","57":"HomeProtectLite","58":"HomeSafe","59":"HomeStarterKit","60":"InternalDemoCookie","61":"KeymanProtect360","62":"KeymanProtect360.Dashboard","63":"KeymanProtect360.Details","64":"LeadForm","65":"Loan Protect 360 Renewal","66":"LoanProtect360","67":"LoanProtect360.Dashboard","68":"LoanProtect360.Details","69":"MaidProtect360","70":"MotoringCardShieldWithUpgrade","71":"Motorshow2020","72":"PartnerProgram","73":"PhoneProtect360","74":"PowerAgentPortal","75":"Prestige","76":"Prestige.Secured","77":"PublicHousingAssured","78":"ReviewUs","79":"SBSTPAProtectLite","80":"SBSTPAProtectPlus","81":"SBSTTravelInsurance","82":"SOA","83":"SimplyGo","84":"SingaporeTravelPass","85":"Touristcard","86":"TravelAssured","87":"TravelAssuredPlus","88":"TravelProtect360","89":"TravelProtect360Plus","90":"cileadform","91":"currencyconverter","92":"freehomeinsurance","94":"motorshow","96":"transferprotect360pro","97":"vCashCard","98":"weather"}[chunkId]||chunkId) + "." + {"0":"db7dd578","1":"eb50a8ff","2":"fb95de0a","3":"7c5dec4c","4":"d22aceac","5":"95297c0f","6":"4e45116a","7":"8c3f16df","8":"fc6a43b9","9":"7bbbc80c","10":"6f24bdfe","11":"5f75f99d","12":"54eb8f7b","13":"2850ccc2","14":"eb2f09b8","15":"f0c7d740","16":"e848b696","17":"87a72e14","18":"73575f02","19":"e711f28a","20":"8514faae","21":"5613c3ba","22":"f67aafaa","23":"708e7abe","24":"67077c01","25":"07767ffb","26":"67a119e8","27":"bcc42ff0","28":"19307da8","29":"f8747b74","30":"5ef9d623","31":"ceecba6c","32":"a2a0404c","33":"6f4234ad","34":"850da63e","35":"8d0b5ac4","36":"f251ec1f","37":"7311166a","38":"cb6e0177","39":"e472412d","40":"564f5e38","41":"b99223cf","42":"3c3bb3b0","43":"57384fe7","44":"7ca06ce4","45":"5bc9074c","46":"689e3b4e","47":"c8448a0a","48":"cbedf879","49":"85203a29","50":"a5676de5","51":"e5d2fed3","52":"c6db4023","53":"8e4923a1","54":"82f7d0df","55":"6b82aab1","56":"d9dccd63","57":"5b6bda31","58":"32afd13d","59":"e48c3759","60":"17eb8647","61":"fc535241","62":"53e47293","63":"3a66eb61","64":"9169d0f3","65":"37fcb36b","66":"22c254fe","67":"c10f4d1b","68":"6d63dd91","69":"c22caab0","70":"883b23ff","71":"b9cc0d81","72":"66ca1946","73":"4bece936","74":"5f603162","75":"9c765aa3","76":"badd710a","77":"dd1c8088","78":"1d0bd062","79":"67d55835","80":"b9836320","81":"03bf1d50","82":"80c07b77","83":"cb94f8f6","84":"ce0271e3","85":"5d68300b","86":"7ed25d27","87":"3a9cdcb7","88":"e1bd70c5","89":"9b709bd1","90":"007821c2","91":"e8d364f5","92":"4d0e3d03","94":"fe44c53f","96":"62753d99","97":"96873c03","98":"fedfd0ed","100":"c9fc1d51","101":"3eaddc0c","102":"baec893d","103":"da7c832d","104":"4930d1be","105":"9f6f6a60","106":"f010f2f7","107":"65093e49","108":"355210bf","109":"43c9ece5","110":"7df9adaa","111":"50cfe9d8","112":"697a4d85","113":"cc8cfdfe","114":"a2f794dc","115":"d9069152","116":"0863a51d","117":"8f765484","118":"1717e3f1","119":"68a9b146","120":"73f49b51","121":"474ea19c","122":"e06cc4ad","123":"3a12ee25","124":"0f6be734","125":"e443987d","126":"070583d2","127":"37779646","128":"1133d5db","129":"028058e9","130":"610d747a","131":"82c75c6e","132":"49963c6a","133":"bb28eeab","134":"518b3143","135":"3b91b836","136":"85c74eb9","137":"e2baa796","138":"1ac89471","139":"e0c72a9a","140":"d70d0a85","141":"4e9c3149","142":"acdb8cfe","143":"dff72584","144":"3999b328","145":"2b1a2496","146":"a977e115","147":"3b5b9de7","148":"e6e531b0","149":"5ab7a910","150":"44606ed6","151":"e3d3b41e","152":"43eb9acf","153":"5515f029","154":"7ea16593","155":"32ff5829","156":"23e60cdf","157":"8bc8e31e","158":"0d2a9be3","159":"81884e61","160":"47c51740","161":"b0bbc753","162":"83eeb5b5","163":"13353c17","164":"6e6cbbd1","165":"7161adb3","166":"0454a9c1","167":"d741d12f","168":"18e61a37","169":"3dff565c","170":"9cffb232","171":"99079167","172":"590096b0","173":"798d3124","174":"e03a94ff","175":"36afd858","176":"5b2b30e9","177":"3994aa73","178":"74a982bd","179":"4abfd22c","180":"e837582a","181":"3b868c60"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"21":1,"22":1,"23":1,"25":1,"28":1,"30":1,"31":1,"32":1,"33":1,"34":1,"37":1,"38":1,"40":1,"41":1,"42":1,"44":1,"47":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"61":1,"64":1,"69":1,"70":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"94":1,"96":1,"97":1,"98":1,"101":1,"102":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"111":1,"112":1,"113":1,"116":1,"120":1,"124":1,"125":1,"129":1,"130":1,"134":1,"135":1,"136":1,"137":1,"138":1,"139":1,"140":1,"141":1,"142":1,"143":1,"144":1,"145":1,"146":1,"147":1,"159":1,"160":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360","45":"EarlyProtect360.Dashboard","46":"EarlyProtect360.Details","47":"EarlyProtect360Plus","48":"EarlyProtect360Plus.Dashboard","49":"EarlyProtect360Plus.Details","50":"FamilyProtect360","51":"FamilyProtectLiteWithUpgrade","52":"FilipinoBond","53":"FlashPayShieldWithUpgrade","54":"FraudProtect360","55":"HIProtect360Protect360","56":"HomeProtect360","57":"HomeProtectLite","58":"HomeSafe","59":"HomeStarterKit","60":"InternalDemoCookie","61":"KeymanProtect360","62":"KeymanProtect360.Dashboard","63":"KeymanProtect360.Details","64":"LeadForm","65":"Loan Protect 360 Renewal","66":"LoanProtect360","67":"LoanProtect360.Dashboard","68":"LoanProtect360.Details","69":"MaidProtect360","70":"MotoringCardShieldWithUpgrade","71":"Motorshow2020","72":"PartnerProgram","73":"PhoneProtect360","74":"PowerAgentPortal","75":"Prestige","76":"Prestige.Secured","77":"PublicHousingAssured","78":"ReviewUs","79":"SBSTPAProtectLite","80":"SBSTPAProtectPlus","81":"SBSTTravelInsurance","82":"SOA","83":"SimplyGo","84":"SingaporeTravelPass","85":"Touristcard","86":"TravelAssured","87":"TravelAssuredPlus","88":"TravelProtect360","89":"TravelProtect360Plus","90":"cileadform","91":"currencyconverter","92":"freehomeinsurance","94":"motorshow","96":"transferprotect360pro","97":"vCashCard","98":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"a858c2f5","20":"31d6cfe0","21":"a858c2f5","22":"86c9f98d","23":"d30bc41f","24":"31d6cfe0","25":"d33f62d9","26":"31d6cfe0","27":"31d6cfe0","28":"58058363","29":"31d6cfe0","30":"05f863ac","31":"ddf1f108","32":"04bc7233","33":"ddf1f108","34":"d33f62d9","35":"31d6cfe0","36":"31d6cfe0","37":"0e4fba13","38":"978e5247","39":"31d6cfe0","40":"ac3f861f","41":"0e4fba13","42":"5d27deaa","43":"31d6cfe0","44":"58058363","45":"31d6cfe0","46":"31d6cfe0","47":"58058363","48":"31d6cfe0","49":"31d6cfe0","50":"ddf1f108","51":"0e4fba13","52":"ddf1f108","53":"0e4fba13","54":"ddf1f108","55":"ddf1f108","56":"471a3a57","57":"471a3a57","58":"471a3a57","59":"0e4fba13","60":"31d6cfe0","61":"58058363","62":"31d6cfe0","63":"31d6cfe0","64":"dd9a60e3","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"14284125","70":"0e4fba13","71":"31d6cfe0","72":"8b647349","73":"471a3a57","74":"716aad65","75":"2fc531d7","76":"cdec5a50","77":"471a3a57","78":"31d6cfe0","79":"39dd3a27","80":"e81d10c5","81":"86c9f98d","82":"d33f62d9","83":"98c15efc","84":"2e8fdc12","85":"344cc04e","86":"86c9f98d","87":"86c9f98d","88":"2e8fdc12","89":"86c9f98d","90":"22b92479","91":"7b4f34de","92":"0e4fba13","94":"49234f01","96":"14284125","97":"94b03ce8","98":"23255cb6","100":"31d6cfe0","101":"cce35a68","102":"440606be","103":"31d6cfe0","104":"2d576837","105":"166c8acc","106":"db5d06da","107":"f93319e8","108":"f93319e8","109":"72c6f688","110":"72c6f688","111":"72c6f688","112":"f93319e8","113":"72c6f688","114":"31d6cfe0","115":"31d6cfe0","116":"6f6df1fe","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"6f6df1fe","121":"31d6cfe0","122":"31d6cfe0","123":"31d6cfe0","124":"6f6df1fe","125":"6f6df1fe","126":"31d6cfe0","127":"31d6cfe0","128":"31d6cfe0","129":"4b48318c","130":"4b48318c","131":"31d6cfe0","132":"31d6cfe0","133":"31d6cfe0","134":"4b48318c","135":"4b48318c","136":"4b48318c","137":"4b48318c","138":"4b48318c","139":"4b48318c","140":"4b48318c","141":"4b48318c","142":"4b48318c","143":"4b48318c","144":"4b48318c","145":"4b48318c","146":"4b48318c","147":"4b48318c","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"31d6cfe0","156":"31d6cfe0","157":"31d6cfe0","158":"31d6cfe0","159":"5fe6802c","160":"5fe6802c","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","174":"31d6cfe0","175":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0","178":"31d6cfe0","179":"31d6cfe0","180":"31d6cfe0","181":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
